export default __webpack_public_path__ + "b26bd4d41265dbb07a3c1039f181dfda.svg";